import styled from 'styled-components';
import { ModuleContainer } from 'components/common/styles';

export const HealthContainer = styled(ModuleContainer)`
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  overflow-y: auto;
`;

export const ContentWrapper = styled.div`
  padding: 12px 16px 16px;
  overflow-x: auto;
  height: 100%;
`;

export const GroupsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorWrapper = styled.div`
  margin: 32px auto;
  padding: 24px 32px;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  background-color: #f8d7da;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
`;

export const ErrorMessage = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #721c24;
`;

export const SummaryBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
  gap: 12px;
`;

export const SummaryCounter = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
`;

export const SummaryActions = styled.div`
  display: flex;
  gap: 10px;
`;

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const GroupTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2f3c7e;
`;

export const ChecksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
`;

export const IconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  align-items: stretch;
`;
